<template>
	<v-breadcrumbs
		:items="breadCrumbItems"
		color="primary"
	>
		<template #divider>
			<v-icon icon="$chevronRight" />
		</template>
	</v-breadcrumbs>
</template>

<script>
export default {
	name: 'BreadCrumbs',
	props: {
		breadCrumbs: {
			type: Object,
			required: false,
			default: () => ({
			}),
		},
		currentTitle: {
			type: String,
			required: true,
		},
	},

	data () {
		return {
			breadCrumbItems: [],
		};
	},

	mounted () {
		for (const breadCrumb in this.breadCrumbs) {
			this.breadCrumbItems.push({
				title: this.$gettext(this.breadCrumbs[breadCrumb]), disabled: false, href: breadCrumb,
			});
		}
		this.breadCrumbItems.push({
			title: this.$gettext(this.currentTitle), disabled: true,
		});
	},
};
</script>

<style scoped>
	.disabled {
		color: grey;
		pointer-events: none;
	}
</style>
